<script setup lang="ts">
import ScaleMenuState from "@/stores/ScaleMenuState";
import type { ScaleConfig } from "@/types/legend.types";
import ScaleRow from "@/components/canvas/DrawerMenus/Settings/ScaleRow.vue";
import ScaleForceSize from "./ScaleForceSize.vue";

/**
 * Choix de l'échelle active + hauteur de texte forcée, dans la popup
 * Légende + échelle des petits écrans. Quand l'échelle a son propre bouton
 * dans l'en-tête, c'est ScaleList qui s'affiche.
 */
function onScaleSelect(name: string) {
  const scale = ScaleMenuState.scales.find((s) => s.name === name);
  if (scale) ScaleMenuState.selectScale(scale);
}

/** Valeur repliée du select : la ligne détaillée est rendue par ScaleRow. */
function scaleLabel(scale: ScaleConfig): string {
  const size = scale.props.textsize ?? scale.props.textstyle?.size;
  return size ? `${scale.name} (${size})` : scale.name;
}
</script>

<template>
  <div class="scale-settings">
    <div class="text-white-50 mb-1">
      <small>{{ $t("canvas:settings.scale.title") }}</small>
    </div>
    <!-- Liste non téléportée : sinon choisir une option compte comme un clic
         hors de la popup, qui se refermerait. -->
    <el-select
      :model-value="ScaleMenuState.activeScale?.name"
      class="legend-select w-100"
      popper-class="legend-select-dropdown"
      size="large"
      :teleported="false"
      @change="onScaleSelect"
    >
      <el-option
        v-for="scale in ScaleMenuState.scales"
        :key="scale.name"
        :label="scaleLabel(scale)"
        :value="scale.name"
      >
        <ScaleRow
          :scale="scale"
          :forced-size="ScaleMenuState.forcedSizeOf(scale)"
        />
      </el-option>
    </el-select>

    <ScaleForceSize class="mt-2" />
  </div>
</template>
